"use client";

import { createContext, useContext } from "react";

export const IsFirstModuleContext = createContext<boolean>(false);

export const useIsFirstModule = () => useContext(IsFirstModuleContext);

interface IsFirstModuleContextProviderProps {
  value: boolean;
  children: React.ReactNode;
}

export const IsFirstModuleContextProvider = ({
  value,
  children,
}: IsFirstModuleContextProviderProps) => {
  return (
    <IsFirstModuleContext.Provider value={value}>
      {children}
    </IsFirstModuleContext.Provider>
  );
};
